import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=803f4e0e&scoped=true&"
import script from "./Order.vue?vue&type=script&lang=js&"
export * from "./Order.vue?vue&type=script&lang=js&"
import style0 from "./Order.vue?vue&type=style&index=0&id=803f4e0e&lang=css&scoped=true&"
import style1 from "./Order.vue?vue&type=style&index=1&id=803f4e0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803f4e0e",
  null
  
)

export default component.exports